import React, { Component } from 'react';

const sizePresets = {
  large: {
    width: 300,
    height: 380
  },
  compact: {
    width: 300,
    height: 80
  },
};

export default class SpotifyPlayer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    
    let { size } = this.props;

    if (typeof size === 'string') {
      size = sizePresets[size]
    }

    return (
      <iframe 
        title="Spotify"
        src={this.props.src}
        width="300" 
        height="80" 
        frameborder="0" 
        allowtransparency="true" 
        allow="encrypted-media"
      />
    )
  }
}